import React from 'react';
import DocumentMeta from 'react-document-meta';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import JsonLd from 'components/JsonLd';
import { isGuideSlug, isVerticalSlug } from 'content/marketingRoutes';
import { I18nProvider } from 'i18n/I18nContext';
import { parseLocale } from 'i18n/localePath';
import IndexPage from 'pages/Index';
import OnboardPage from 'pages/Onboard';
import NotFoundPage from 'pages/404';
import TermsPage from 'pages/TermsPage';
import PrivacyPage from 'pages/PrivacyPage';
import CookiesPage from 'pages/CookiesPage';
import ContactPage from 'pages/ContactPage';
import ComparePage from 'pages/ComparePage';
import ChecklistPage from 'pages/ChecklistPage';
import PricingPage from 'pages/PricingPage';
import VerticalsIndexPage from 'pages/VerticalsIndexPage';
import VerticalPage from 'pages/VerticalPage';
import GuidesIndexPage from 'pages/GuidesIndexPage';
import GuidePage from 'pages/GuidePage';
import absoluteUrl from 'seo/absoluteUrl';
import buildHomeJsonLd from 'seo/jsonLd';
import buildDocumentMetaProps from 'seo/pageMeta';
import logo from 'static/images/logo@2x.png';

function renderPage(strippedPath: string) {
  if (strippedPath === '/for') return <VerticalsIndexPage />;
  if (strippedPath.startsWith('/for/')) {
    const slug = strippedPath.slice('/for/'.length);
    if (isVerticalSlug(slug)) return <VerticalPage slug={slug} />;
  }
  if (strippedPath === '/guides') return <GuidesIndexPage />;
  if (strippedPath.startsWith('/guides/')) {
    const slug = strippedPath.slice('/guides/'.length);
    if (isGuideSlug(slug)) return <GuidePage slug={slug} />;
  }

  switch (strippedPath) {
    case '/':
      return <IndexPage />;
    case '/onboard':
      return <OnboardPage />;
    case '/terms':
      return <TermsPage />;
    case '/privacy':
      return <PrivacyPage />;
    case '/cookies':
      return <CookiesPage />;
    case '/contact':
      return <ContactPage />;
    case '/compare':
      return <ComparePage />;
    case '/checklist':
      return <ChecklistPage />;
    case '/pricing':
      return <PricingPage />;
    default:
      return <NotFoundPage />;
  }
}

const App = ({ location, history }: RouteComponentProps) => {
  const { locale, strippedPath } = parseLocale(location.pathname);
  const ogImageUrl = absoluteUrl(logo);
  const documentMeta = buildDocumentMetaProps({
    pathname: strippedPath,
    ogImageUrl,
    locale,
  });
  const homeJsonLd = strippedPath === '/' ? buildHomeJsonLd({ ogImageUrl, locale }) : null;

  return (
    <I18nProvider locale={locale} strippedPath={strippedPath} history={history}>
      <DocumentMeta {...documentMeta} />
      {homeJsonLd ? <JsonLd data={homeJsonLd} /> : null}

      {renderPage(strippedPath)}
    </I18nProvider>
  );
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.tsx